import React from 'react'

export default function Adv() {
    return (
        <div>
            <div className="container py-10">
                <h1 className='text-[32px] font-semibold '>Advertising</h1>
                <div className='mt-3 font-semibold'>
                    <p>Call:</p>
                    <p className='text-[#E50914] text-xl'>+91 234 567 8765</p>
                    <p className='text-sm text-black text-opacity-50'>You can send any questions related to advertising to  <span className='text-[#E50914] text-opacity-100 font-semibold'>reklama@FireNews.com</span> </p>
                </div>
            </div>
        </div>
    )
}
